const isEnvProduction =
  typeof BUILD_ENV === 'string' && BUILD_ENV === 'production';

export const CONFIG = {
  /**
   * JS Application name, either 'common' - for affiliates or 'admin' - for managers.
   *
   * @type {String}
   */
  APP_NAME: typeof APP_NAME === 'string' ? APP_NAME : '',

  /**
   * Whether production mode enabled
   *
   * @type {Boolean}
   */
  IS_ENV_PRODUCTION: isEnvProduction,

  /**
   * Whether error reporting enabled
   *
   * @type {Boolean}
   */
  ERROR_REPORTING_ENABLED: isEnvProduction,

  /**
   * Google captcha site key
   *
   * @type {String}
   */
  GOOGLE_CAPTCHA_SITE_KEY: '6Lfrl0EUAAAAAEywY-8ygkAF8I3bH4LlY_Hcbaas',
};

export const FIRST_VISIT_FROM_LS_KEY = 'firstVisitFrom';
export const WAS_COOKIES_POLICY_ACCEPTED_LS_KEY = 'wasCookiesPolicyAccepted';
